import { useEffect, useState } from "react";
import { Clock as ClockIcon } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export function Clock({ className = "" }) {
  const { lang } = useLang();
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const locale = lang === "es" ? "es-ES" : "en-US";
  const fecha = now.toLocaleDateString(locale, {
    weekday: "long", year: "numeric", month: "long", day: "numeric",
  });
  const hora = now.toLocaleTimeString(locale, {
    hour: "2-digit", minute: "2-digit", second: "2-digit",
  });

  return (
    <div className={`flex items-center gap-2 text-sm ${className}`} data-testid="live-datetime">
      <ClockIcon size={14} className="opacity-70" />
      <span className="capitalize" data-testid="live-date">{fecha}</span>
      <span className="opacity-50">·</span>
      <span className="tabular-nums" data-testid="live-time">{hora}</span>
    </div>
  );
}
